import { SET_ACCOUNT_ID } from '../actions/types';

export default function accountIdReducer(state = {}, action) {
	switch (action.type) {
		case SET_ACCOUNT_ID:
			return {
				...state,
				accountId: action.payload
			};
		default:
			return state;
	}
}
